import { InterestsWebScreenBody } from './interests-web-screen-body';
import type { InterestsScreenState } from './use-interests-screen';

/** Small UI: stacked footer on the suggestions step. */
export function InterestsScreenBodySmall(props: InterestsScreenState) {
  return <InterestsWebScreenBody layout="small" state={props} />;
}
